import { Alert } from "reactstrap";
import { useLockState } from "./LockCheck";

const LockedBanner = ({entityName}) => {
    const lockState = useLockState();
    if (process.env.REACT_APP_ENABLE_SIGNALR === "false" || !lockState.isConnected) return;

    return (
        <>
            {
                /* 🔒 Banner if the entity lock has been overriden, without 2 users using the same entity at the same time */
                lockState.lockOverride.isOn ?
                    <Alert style={{ backgroundColor: "#c3711aff" }} className="m-2">
                        <i className="bi bi-lock-fill me-2"></i>
                        {lockState.lockOverride.message}
                    </Alert>
                /* 🔒 Banner if locked by another user */
                : lockState.lockedBy.userGuid && lockState.lockedBy.userGuid !== lockState.currentUser.userGuid ?
                    <Alert color="warning" className="m-2">
                        <i className="bi bi-lock-fill me-2"></i>
                        This {entityName} is currently locked by <strong>{lockState.lockedBy.username}</strong>. Editing is disabled.
                    </Alert>
                /* 🔒 Banner if locked by myself in the same tab*/
                : lockState.lockedBy.connectionId && lockState.lockedBy.connectionId === lockState.currentUser.connectionId ?
                    <span></span>
                    // <Alert className="m-2">
                    //     <i className="bi bi-lock-fill me-2"></i>
                    //     You locked the {entityName}.
                    // </Alert>
                /* 🔒 Banner if locked by myself in another tab*/
                : lockState.lockedBy.clientIp && lockState.lockedBy.clientIp === lockState.currentUser.clientIp ?                    
                    <Alert color="warning" className="m-2">
                        <i className="bi bi-lock-fill me-2"></i>
                        You locked the {entityName} in another tab.
                    </Alert>
                :
                /* 🔒 Banner if locked by myself in another device*/
                    <Alert color="warning" className="m-2">
                        <i className="bi bi-lock-fill me-2"></i>
                        You locked the {entityName} in another device.
                    </Alert>
            }
        </>
    );
}
export default LockedBanner;